import React, { Component } from 'react';
import { Parallax } from 'react-parallax';
import { Row, Col, Input, Button } from 'react-materialize';
import { HOSTNAME } from '../config.js';
import { LandingCards } from './landingCards';
import '../css/landing.css';

import logo from '../img/logo.png';

export class Landing extends Component {
  constructor(props) {
    super(props);
    this.handleMail = this.handleMail.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleMail () {
    let name = document.getElementById('formName').value;
    let phone = document.getElementById('formPhone').value;

    if ((name !== '') && (phone !== '')) {
      var http = new XMLHttpRequest();
      var url = HOSTNAME + 'php/sendMail.php';
      var params = 'name=' + name +'&phone=' + phone;
      http.open('POST', url, true);
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

      http.onreadystatechange = function() {
        document.getElementById('thanks').style.display = "block";
        if (http.readyState === 4 && http.status === 200) {
          console.log(http.responseText);
        }
      }
      http.send(params);
    } else {
      if (name === '') {
        document.getElementById('formName').classList.add("input-empty");
      } else {
        document.getElementById('formName').classList.remove("input-empty");
      }

      if (phone === '') {
        document.getElementById('formPhone').classList.add("input-empty");
      } else {
        document.getElementById('formPhone').classList.remove("input-empty");
      }
    }
  }

  render() {
    return(
      <div className="landing">
        <Parallax
          blur={0}
          bgImage={require('../img/landing_images/background-1.jpeg')}
          bgImageAlt="ООО Меридиан БКД"
          strength={200}>
          <div style={{ height: '600px' }}>
            <div className="container">
              <Row className='greeting-field'>
                <Col s={12} m={6} className="greeting">
                  <img src={logo}/>
                  <h3>ВАША БЕЗОПАСНОСТЬ И КОМФОРТ НА ДОРОГАХ</h3>
                </Col>
                <Col m={2}></Col>
                <Col s={12} m={4} className='form'>
                  <Input label="Как Вас зовут?" type='text' id='formName'></Input>
                  <Input label="Ваш номер телефона" type='text' id='formPhone'></Input>
                  <Button waves='light' className='btn-field' onClick={this.handleMail}>обратный звонок</Button>
                  <p id="thanks">Спасибо за заявку! Совсем скоро мы вам перезвоним</p>
                </Col>
              </Row>
            </div>
          </div>
        </Parallax>
        <div className="section">
          <Row>
            <Col s={4} m={4} className='blue-line'>
              <div className="icon-block">
                <h2 className="center brown-text"><i className="material-icons">local_shipping</i></h2>
                <h5 className="center">Доставка</h5>
              </div>
            </Col>
            <Col s={4} m={4} className='blue-line'>
              <div className="icon-block">
                <h2 className="center brown-text"><i className="material-icons">build</i></h2>
                <h5 className="center">Установка</h5>
              </div>
            </Col>
            <Col s={4} m={4} className='blue-line'>
              <div className="icon-block">
                <h2 className="center brown-text"><i className="material-icons">keyboard</i></h2>
                <h5 className="center">Расчет</h5>
              </div>
            </Col>
          </Row>
        </div>
        <Parallax
          blur={0}
          bgImage={require('../img/landing_images/background-2.jpeg')}
          bgImageAlt="ООО Меридиан БКД"
          strength={200}>
          <LandingCards/>
        </Parallax>
      </div>
    );
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/components/landing.js